;(() => {
  document.addEventListener("DOMContentLoaded", () => {
    
    // 1. SÉCURITÉ : PAGE PRODUIT UNIQUEMENT
    if (!window.location.pathname.includes('/products/')) return;

    // DÉSACTIVER sur le coussin cervical
    if (window.location.href.toLowerCase().includes('coussin-dalignement-cervical')) return;

    // --- CONFIGURATION ---
    const isPatchPage = window.location.href.toLowerCase().includes("cryo-patch-migraine");
    const cushionVariantId = 50254567407944; 
    const cushionPrice = 22.90;
    
    // Seuil scroll : 1200 pour Patch (un peu moins haut pour être sûr qu'il apparaisse), 300 autres
    const scrollThreshold = isPatchPage ? 1200 : 300;

    // --- CRÉATION DU STICKY ---
    const stickyATC = document.createElement("div");
    stickyATC.className = "sticky-atc";
    document.body.appendChild(stickyATC);

    // --- 1. RÉCUPÉRATION IMAGE ---
    function getProductImage() {
        const selectors = [
            ".product__media img", ".product-media img", ".featured-image", 
            "#ProductPhotoImg", ".product-image", ".grid__item img", "img[alt*='Cryo']"
        ];
        for (let sel of selectors) {
            const img = document.querySelector(sel);
            if (img) return img.dataset.src || img.currentSrc || img.src;
        }
        return "";
    }

    // --- 2. RÉCUPÉRATION TITRE ---
    function getProductTitle() {
        if (isPatchPage) return "Cryo Patch Anti-Migraine";
        const h1 = document.querySelector("h1");
        return h1 ? h1.innerText.trim() : document.title;
    }

    // --- 3. RÉCUPÉRATION PRIX & VARIANTE (COEUR DU SYSTÈME) ---
    function getData() {
        // --- CAS A : PAGE PATCH (Calcul Bundle) ---
        if (isPatchPage) {
            try {
                const activeOption = document.querySelector(".cryo-option.active");
                let basePrice = 49.90;
                let variantName = "4 Packs";

                if (activeOption) {
                    let priceStr = activeOption.getAttribute("data-price"); 
                    if(priceStr) basePrice = parseFloat(priceStr.replace('€','').replace(',','.'));
                    let titleEl = activeOption.querySelector(".cryo-offer-title");
                    if(titleEl) variantName = titleEl.innerText.trim();
                }

                const cb = document.getElementById('cryoBumpCheckbox');
                const hasCushion = cb && cb.checked;
                
                let finalPrice = basePrice;
                if (hasCushion) finalPrice += cushionPrice;

                return {
                    priceText: finalPrice.toFixed(2).replace('.', ',') + "€",
                    variantText: hasCushion ? variantName + " + Cryo Coussin" : variantName
                };
            } catch (e) {
                return { priceText: "49,90€", variantText: "4 Packs" };
            }
        } 
        
        // --- CAS B : AUTRES PAGES (Scraping Intelligent) ---
        else {
            const priceSelectors = [
                '.price__current', 
                '.price-item--regular', 
                '.price-item--sale',
                '.product__price', 
                '#ProductPrice', 
                '.price .money', 
                '[data-product-price]',
                '.current_price'
            ];

            let foundPrice = "";
            for (let sel of priceSelectors) {
                const el = document.querySelector(sel);
                if (el && el.innerText.trim() !== "") {
                    foundPrice = el.innerText.trim().replace(/\s/g, ''); 
                    break;
                }
            }

            const variantEl = document.querySelector('.product-form__selected-value, .single-option-selector, .current-variant');
            const variantTxt = variantEl ? variantEl.innerText.trim() : "";

            return { 
                priceText: foundPrice || "22,90€",
                variantText: variantTxt 
            };
        }
    }

    // --- ACTION AJOUT PANIER ---
    function triggerAddToCart() {
        const btn = stickyATC.querySelector(".sticky-atc-button");
        if(btn) { btn.innerHTML = "Ajout..."; btn.disabled = true; }

        if (isPatchPage) {
            const activeOption = document.querySelector(".cryo-option.active");
            const packId = activeOption ? activeOption.getAttribute("data-variant") : "50420023165256";
            
            const items = [{ id: parseInt(packId), quantity: 1 }];
            const cb = document.getElementById('cryoBumpCheckbox');
            if(cb && cb.checked) items.push({ id: cushionVariantId, quantity: 1 });

            fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ items: items })
            })
            .then(r => r.json())
            .then(() => {
                if (typeof window.openCustomCartDrawer === "function") window.openCustomCartDrawer();
                else window.location.href = "/cart";
            })
            .finally(() => { setTimeout(render, 1000); });
        } else {
            const mainFormBtn = document.querySelector('form[action*="/cart/add"] [type="submit"], button[name="add"], .product-form__submit');
            if(mainFormBtn) {
                mainFormBtn.click();
                setTimeout(() => { if(btn) { btn.innerHTML = "Ajouter au panier"; btn.disabled = false; } }, 2000);
            } else {
                const idInput = document.querySelector('[name="id"]');
                if(idInput) {
                     fetch("/cart/add.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ items: [{id: idInput.value, quantity: 1}] })
                    }).then(() => window.location.href = "/cart");
                }
            }
        }
    }

    function isMobile() { return window.innerWidth <= 768; }

    // --- RENDU VISUEL ---
    function render() {
        const data = getData();
        const img = getProductImage();
        const title = getProductTitle();
        const displayPrice = data.priceText;

        if (isMobile()) {
            stickyATC.innerHTML = `
              <div class="sticky-atc-container mobile">
                 <button class="sticky-atc-button mobile-btn">
                    <span class="btn-price">${displayPrice}</span> • <span>Ajouter au panier</span>
                 </button>
              </div>
            `;
        } else {
            const imgHTML = img ? `<div class="img-wrapper"><img src="${img}" class="sticky-img"></div>` : "";
            
            stickyATC.innerHTML = `
              <div class="sticky-atc-container desktop">
                <div class="sticky-left">
                    ${imgHTML}
                    <div class="sticky-info">
                      <div class="sticky-title">${title}</div>
                      ${data.variantText ? `<div class="sticky-variant">${data.variantText}</div>` : ''}
                    </div>
                </div>
                <div class="sticky-right">
                    <div class="sticky-price">${displayPrice}</div>
                    <button class="sticky-atc-button desktop-btn">Ajouter au panier</button>
                </div>
              </div>
            `;
        }

        const btn = stickyATC.querySelector(".sticky-atc-button");
        if(btn) btn.onclick = (e) => { e.preventDefault(); triggerAddToCart(); };
    }

    // --- STYLES CSS ---
    const style = document.createElement('style');
    style.innerHTML = `
      .sticky-atc {
        position: fixed; 
        z-index: 2147483647; 
        pointer-events: none;
        opacity: 0; 
        transition: all 0.4s ease;
      }
      .sticky-atc.visible { opacity: 1; pointer-events: auto; }

      .sticky-atc-button {
        background: linear-gradient(90deg,#92D8E0,#67c7d2);
        color: #fff;
        border: none;
        border-radius: 999px;
        font-weight: 700;
        cursor: pointer;
        box-shadow: 0 4px 15px rgba(103,199,210,0.4);
        transition: transform 0.2s;
        white-space: nowrap;
      }
      .sticky-atc-button:hover { transform: scale(1.02); }

      /* --- MOBILE --- */
      @media (max-width: 768px) {
        .sticky-atc {
            bottom: 20px; left: 0; right: 0;
            display: flex; justify-content: center;
            transform: translateY(100%);
        }
        .sticky-atc.visible { transform: translateY(0); }
        
        .sticky-atc-container.mobile {
            background: transparent; 
            box-shadow: none; 
            padding: 0; 
            width: 92%; 
            max-width: 450px;
        }
        .mobile-btn {
            width: 100%; padding: 14px 20px; font-size: 16px;
            display: flex; justify-content: center; gap: 8px;
        }
      }

      /* --- DESKTOP --- */
      @media (min-width: 769px) {
        .sticky-atc {
            bottom: 20px; right: 20px; left: auto;
            transform: translateY(100px);
        }
        .sticky-atc.visible { transform: translateY(0); }

        .sticky-atc-container.desktop {
            background: white;
            padding: 10px 20px; 
            border-radius: 12px;
            box-shadow: 0 5px 25px rgba(0,0,0,0.15); 
            display: flex; align-items: center; justify-content: space-between; gap: 20px;
            min-width: 420px;
        }

        .sticky-left { display: flex; align-items: center; gap: 15px; }
        .img-wrapper { width: 50px; height: 50px; border-radius: 8px; overflow: hidden; border: 1px solid #eee; flex-shrink:0; background: #fff; }
        .sticky-img { width: 100%; height: 100%; object-fit: cover; }
        
        .sticky-info { text-align: left; }
        .sticky-title { font-weight: 700; font-size: 14px; color: #111; line-height: 1.2; }
        .sticky-variant { font-size: 12px; color: #666; margin-top: 3px; }

        .sticky-right { display: flex; align-items: center; gap: 15px; }
        .sticky-price { font-weight: 700; font-size: 18px; color: #111; white-space: nowrap; margin-right: 5px; }
        
        .desktop-btn { padding: 10px 25px; font-size: 14px; }
      }
    `;
    document.head.appendChild(style);

    // --- EVENTS & INIT ---
    render();

    window.addEventListener("scroll", () => {
        if (window.scrollY > scrollThreshold) stickyATC.classList.add("visible");
        else stickyATC.classList.remove("visible");
    });
    window.addEventListener("resize", render);

    // Observer si le Bundle Change (Patch)
    if (isPatchPage) {
        document.addEventListener("click", (e) => {
            if(e.target.closest(".cryo-option")) setTimeout(render, 50);
        });
        document.addEventListener('change', (e) => {
            if(e.target.id === 'cryoBumpCheckbox') render();
        });
    }
  });
})();